import { PureComponent } from 'react';

import wlConfig from '../../constants/wlConfig';
import Footer from '../Footer';
import Logo from '../Logo';

import './ErrorBoundaryView.css';

const {
  errorPageConfig: { backgroundImgSrc = '' },
} = wlConfig;

class ErrorBoundaryView extends PureComponent {
  render() {
    const { isLoggedIn } = this.props;
    return (
      <div className="ErrorBoundaryView">
        <div
          className="ErrorBoundaryView-bgWrapper"
          style={{
            backgroundImage: `url(${backgroundImgSrc}`,
          }}
        >
          <div className="ErrorBoundaryView-container">
            <Logo overrideClasses={{ root: 'ErrorBoundaryView-logo' }} />
            <h2 className="ErrorBoundaryView-heading">
              Oops! Something went wrong :(
            </h2>
            <p className="ErrorBoundaryView-info">
              It looks like we&apos;ve run into an error. Please try refreshing
              the page.
              <br />
              If you continue to experience issues please contact us at{' '}
              <a href="mailto:support@gettoggle.com">support@gettoggle.com</a>.
              <br />
              We apologize for the inconvenience.
            </p>
          </div>
        </div>
        <Footer isLoggedIn={isLoggedIn} />
      </div>
    );
  }
}

export default ErrorBoundaryView;
